<template lang="pug">
div
  Form(:data="feedbackPoint", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useFeedbackPointAdd from './useFeedbackPointAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, feedbackPoint, isSubmitting } = useFeedbackPointAdd()

    return {
      feedbackPoint,
      create,
      isSubmitting,
    }
  },
}
</script>
